<template>
<div class="animated fadeIn">
  <b-card>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="showAddRole">Add Role</b-btn>
    </b-button-toolbar>
  </b-card>

  <b-card>
    <v-client-table :columns="columns" :data="roles" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="permissions" slot-scope="data">
        <ul>
          <li v-for="permission in data.row.permissions">
            {{ permission.name }}
          </li>
        </ul>
      </template>
      <template slot="actions" slot-scope="data">
        <b-btn size="sm" variant="outline-success" @click="showRolePermissions(data.row)" class="mr-1">Permissions</b-btn>
        <b-btn size="sm" variant="outline-primary" @click="showEditRole(data.row)" class="mr-1">Edit</b-btn>
        <b-btn size="sm" variant="outline-danger" @click="showDeleteRole(data.row)">Delete</b-btn>
      </template>
    </v-client-table>
  </b-card>

  <div>
    <b-modal ref="modalAddRole" title="Add Role" hide-footer @hide="hideAddRole" no-enforce-focus>
      <role-form-add v-if="canShowAddRole" @success="addRoleSuccess" @cancel="cancelAddRole" />
    </b-modal>
    <b-modal ref="modalEditRole" title="Edit Role" hide-footer @hide="hideEditRole" no-enforce-focus>
      <role-form-edit v-if="selectedRole" :role="selectedRole" @success="editRoleSuccess" @cancel="cancelEditRole" />
    </b-modal>
    <b-modal ref="modalRolePermissions" title="Set Role Permissions" hide-footer @hide="hideRolePermissions" no-enforce-focus>
      <role-permissions v-if="selectedRole" :role="selectedRole" @success="setRolePermissionsSuccess" @cancel="cancelRolePermissions" />
    </b-modal>
    <b-modal ref="modalConfirm" title="Delete Role" @ok="deleteRole">
      <div v-if="selectedRole" class="d-block text-center">
        <h4>Are you sure you want to delete this role?</h4>
      </div>
    </b-modal>
  </div>

</div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import Vue from 'vue'
import RoleFormAdd from './RoleFormAdd'
import RoleFormEdit from './RoleFormEdit'
import RolePermissions from './RolePermissions'

export default {
  name: 'RoleList',
  components: {
    RoleFormAdd,
    RoleFormEdit,
    RolePermissions
  },
  data: function() {
    return {
      selectedRole: null,
      columns: ['id', 'name', 'permissions', 'actions'],
      options: {
        headings: {
          id: 'ID'
        },
        sortable: [],
        filterable: ['id', 'name'],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      canShowAddRole: false,
    }
  },
  computed: mapState({
    roles: state => state.roles.all
  }),
  methods: {
    showAddRole() {
      this.canShowAddRole = true
      this.$refs.modalAddRole.show()
    },
    cancelAddRole() {
      this.$refs.modalAddRole.hide()
    },
    addRoleSuccess() {
      this.$refs.modalAddRole.hide()
      this.$store.dispatch('roles/getRoles')
    },
    hideAddRole() {
      this.canShowAddRole = false
    },
    showEditRole(role) {
      this.selectedRole = role
      this.$refs.modalEditRole.show()
    },
    cancelEditRole() {
      this.$refs.modalEditRole.hide()
    },
    editRoleSuccess() {
      this.$refs.modalEditRole.hide()
      this.$store.dispatch('roles/getRoles')
    },
    hideEditRole() {
      this.selectedRole = null
    },
    showDeleteRole(role) {
      this.selectedRole = role
      this.$refs.modalConfirm.show()
    },
    deleteRole() {
      this.$store.dispatch('roles/deleteRole', {id: this.selectedRole.id})
      .then(() => {
        this.showSuccessMsg()
        this.$store.dispatch('roles/getRoles')
      })
      .catch((error) => {
        if (error.response.status == 422) {
          this.showErrorMsg({
            message: this.getResponseErrorMessage(error.response.data)
          })
        } else {
          this.showErrorMsg()
        }
      })
    },
    showRolePermissions(role) {
      this.selectedRole = role
      this.$refs.modalRolePermissions.show()
    },
    cancelRolePermissions() {
      this.$refs.modalRolePermissions.hide()
    },
    setRolePermissionsSuccess() {
      this.$refs.modalRolePermissions.hide()
      this.$store.dispatch('roles/getRoles')
    },
    hideRolePermissions() {
      this.selectedRole = null
    },
  },
  created() {
    this.$store.dispatch('roles/getRoles')
    this.$store.dispatch('permissions/getPermissions')
  }
}
</script>
